import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { useCustomerType } from '../../../../modules/apis/student/products'
import { APP_SCREEN_NAME } from '../../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useReturnFullUrl from '../../../../modules/hooks/webview/common/useReturnFullUrl'
import { n_book_lessons, n_common } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { COLORS } from '../../../../modules/vars'

const NoPackageModal = ({ showNoAvailablePackage, setShowNoAvailablePackage }) => {
  const { data: customerType } = useCustomerType()
  const router = useAppRouter()
  const { t } = useTranslation()
  const getFullUrl = useReturnFullUrl()
  return (
    <DSModal
      id="showNoAvailablePackage"
      isOpen={showNoAvailablePackage}
      setIsOpen={setShowNoAvailablePackage}
      size="lg"
    >
      {customerType?.isMulticampus ? (
        <>
          <DSModal.Title>{t(n_book_lessons.no_credit.title)}</DSModal.Title>
          <DSModal.Content>멀티캠퍼스 플랫폼에서 다음 과정를 신청해보세요</DSModal.Content>
          <DSModal.ButtonContainer direction="horizontal">
            <DSButton
              className="whitespace-nowrap"
              size={BUTTON_SIZE.MD}
              onClick={() => setShowNoAvailablePackage(false)}
            >
              <DSButton.Label>확인</DSButton.Label>
            </DSButton>
          </DSModal.ButtonContainer>
        </>
      ) : (
        <>
          <DSModal.Title>{t(n_book_lessons.no_credit.title)}</DSModal.Title>
          <DSModal.Content>{t(n_book_lessons.no_credit.subtitle)}</DSModal.Content>
          <DSModal.ButtonContainer direction="horizontal">
            <DSButton
              size={BUTTON_SIZE.MD}
              type={BUTTON_TYPE.OUTLINE}
              customBgColor={COLORS.WHITE}
              className="whitespace-nowrap"
              onClick={() => setShowNoAvailablePackage(false)}
            >
              <DSButton.Label>{t(n_common.btn_cancel)}</DSButton.Label>
            </DSButton>
            <DSButton
              className="whitespace-nowrap"
              size={BUTTON_SIZE.MD}
              onClick={() =>
                router.push(`${urls.student.newPortal.pricing.index}`, {
                  appScreenName: APP_SCREEN_NAME.STACK_SCREEN,
                  appSendData: {
                    url: getFullUrl(`${urls.student.portal.pricing.index}?app=true`),
                  },
                })
              }
            >
              <DSButton.Label>{t(n_book_lessons.no_credit.btn_purchase_credit)}</DSButton.Label>
            </DSButton>
          </DSModal.ButtonContainer>
        </>
      )}
    </DSModal>
  )
}
export default NoPackageModal
